<template>
  <div class="sidebar">

    <div class="section" v-for="item in blogsType" :key="item.id">
      
      <div class="section-header">
        {{ item.title }}
      </div>

      <a-menu mode="inline" :selectable="false" class="custom-menu">
        <a-menu-item 
          v-for="child in item.children" 
          :key="child.id"
        >
          <span class="dot">•</span>
          {{ child.title }}
        </a-menu-item>
      </a-menu>

    </div>

  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { apiRedis } from '@/api/index'

const blogsType = ref<any[]>([])

onMounted(async () => {
  await getBlogsType()
})

const buildTree = (data: any[]) => {
  const map: any = {}
  const roots: any[] = []

  data.forEach(item => {
    map[item.id] = { ...item, children: [] }
  })

  data.forEach(item => {
    if (item.parent_id) {
      map[item.parent_id]?.children.push(map[item.id])
    } else {
      roots.push(map[item.id])
    }
  })

  return roots
}

const getBlogsType = async () => {
  const res: any = await apiRedis("profile-blogs-type")
  const data = JSON.parse(res.data.data)

  blogsType.value = buildTree(data)
  console.log('blogsType',blogsType)
}
</script>

<style scoped>
.sidebar {
  /* width: 300px; */
  /* background: #f3f3f3; */
  padding: 16px;
}

.section {
  margin-bottom: 24px;
}
.section ul {
  background: #f3f3f3 !important;

}
.layout-default section, .layout-default .section {
    padding: unset;
}
.section-header {
  background: linear-gradient(to right, #d8b06a, #e6c98f);
  color: white;
  font-weight: 600;
  padding: 12px 16px;
  font-size: 16px;
}

.custom-menu {
  background: transparent;
  border: none;
}

.custom-menu :deep(.ant-menu-item) {
  height: 40px;
  line-height: 40px;
  padding-left: 20px !important;
  color: #555;
  font-size: 15px;
}

.custom-menu :deep(.ant-menu-item:hover) {
  background: transparent;
  color: #d8b06a;
}

.dot {
  margin-right: 8px;
  color: #d8b06a;
  font-weight: bold;
}
</style>